// pages/Agents/AgentSpace/AgentSpace.js
// Agent Space main page. The FAB itself is rendered globally by ChatbotLayout
// (so the chat bubble is available on every chatbot panel page). Here we
// only render:
//   - The landing (agents list + cross-agent activity/scheduled tables) when
//     no agent is selected.
//   - The per-agent workflows page (AgentSpaceAgentDetail) when one is.
// Agent selection + refresh keys come from AgentSpaceContext, which is
// shared with the FAB.
import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import AgentSpaceAgentDetail from './AgentSpaceAgentDetail';
import AgentSpaceLanding from './AgentSpaceLanding';
import AgentSpaceAgentSettings from './AgentSpaceAgentSettings';
import { useAgentSpace } from '../../../../contexts/AgentSpaceContext';

const fontFamily = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif";

export default function AgentSpace() {
    const { chatbotId } = useParams();
    const {
        selectedAgent,
        selectAgent,
        clearSelectedAgent,
        workflowsRefreshKey,
        agentMode,
    } = useAgentSpace();

    return (
        <Box sx={{
            fontFamily,
            maxWidth: '1200px',
            width: '100%',
            height: { xs: 'calc(100vh - 80px)', sm: 'calc(100vh - 120px)' },
            mx: 'auto',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
        }}>
            {selectedAgent ? (
                agentMode === 'settings' ? (
                    <AgentSpaceAgentSettings
                        chatbotId={chatbotId}
                        agentType={selectedAgent}
                        onBack={clearSelectedAgent}
                    />
                ) : (
                    <AgentSpaceAgentDetail
                        chatbotId={chatbotId}
                        agentType={selectedAgent}
                        onBack={clearSelectedAgent}
                        refreshKey={workflowsRefreshKey}
                    />
                )
            ) : (
                <AgentSpaceLanding
                    chatbotId={chatbotId}
                    onSelectAgent={selectAgent}
                    refreshKey={workflowsRefreshKey}
                />
            )}
        </Box>
    );
}
